const SECTION_TYPE = 'eb-section'
const ROW_TYPE = 'eb-row'
const COLUMN_TYPE = 'eb-column'

const layoutStyles = `
.eb-section {
  width: 100%;
  padding: 40px 20px;
  box-sizing: border-box;
}
.eb-row {
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.eb-column {
  flex: 1;
  min-height: 50px;
  padding: 10px;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .eb-row {
    flex-direction: column;
  }
  .eb-column {
    flex-basis: 100% !important;
    width: 100% !important;
  }
}
`

export default function elementorLayout(editor) {
  const dc = editor.DomComponents
  const bm = editor.BlockManager

  dc.addType(SECTION_TYPE, {
    isComponent(el) {
      return el.tagName === 'SECTION' && el.classList && el.classList.contains('eb-section')
    },
    model: {
      defaults: {
        tagName: 'section',
        name: 'Section',
        draggable: 'body, [data-gjs-type=wrapper]',
        droppable: `.${ROW_TYPE}, [data-gjs-type="${ROW_TYPE}"]`,
        attributes: { class: 'eb-section' },
        styles: layoutStyles,
        traits: [
          { type: 'text', name: 'id', label: 'Section ID' },
        ],
      },
    },
  })

  dc.addType(ROW_TYPE, {
    isComponent(el) {
      return el.tagName === 'DIV' && el.classList && el.classList.contains('eb-row')
    },
    model: {
      defaults: {
        tagName: 'div',
        name: 'Row',
        draggable: `.${SECTION_TYPE}, [data-gjs-type="${SECTION_TYPE}"]`,
        droppable: `.${COLUMN_TYPE}, [data-gjs-type="${COLUMN_TYPE}"]`,
        attributes: { class: 'eb-row' },
        traits: [],
      },
    },
  })

  dc.addType(COLUMN_TYPE, {
    isComponent(el) {
      return el.tagName === 'DIV' && el.classList && el.classList.contains('eb-column')
    },
    model: {
      defaults: {
        tagName: 'div',
        name: 'Column',
        draggable: `.${ROW_TYPE}, [data-gjs-type="${ROW_TYPE}"]`,
        droppable: true,
        attributes: { class: 'eb-column' },
        traits: [],
      },
    },
  })

  const sectionIcon = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"/></svg>'
  const col2Icon = '<svg viewBox="0 0 23 24"><path fill="currentColor" d="M2 20h8V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM13 20h8V4h-8v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Z"/></svg>'
  const col3Icon = '<svg viewBox="0 0 23 24"><path fill="currentColor" d="M2 20h4V4H2v16ZM17 20h4V4h-4v16ZM9.5 20h4V4h-4v16Z"/></svg>'
  const col4Icon = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M2 20h3V4H2v16ZM7 20h3V4H7v16ZM12 20h3V4h-3v16ZM17 20h3V4h-3v16Z"/></svg>'

  function buildColumns(widths) {
    return widths.map(w => `<div data-gjs-type="${COLUMN_TYPE}" class="eb-column" style="flex-basis:${w}%;width:${w}%;"></div>`).join('')
  }

  function sectionBlock(id, label, media, widths) {
    bm.add(id, {
      label,
      media,
      category: 'Layout',
      select: true,
      content: `<section data-gjs-type="${SECTION_TYPE}" class="eb-section">
        <div data-gjs-type="${ROW_TYPE}" class="eb-row">
          ${buildColumns(widths)}
        </div>
      </section>`,
    })
  }

  sectionBlock('section-1col', '1 Column', sectionIcon, [100])
  sectionBlock('section-2col', '2 Columns', col2Icon, [50, 50])
  sectionBlock('section-2col-3-7', '2 Col (30/70)', col2Icon, [30, 70])
  sectionBlock('section-2col-7-3', '2 Col (70/30)', col2Icon, [70, 30])
  sectionBlock('section-2col-1-3', '2 Col (33/66)', col2Icon, [33.33, 66.66])
  sectionBlock('section-3col', '3 Columns', col3Icon, [33.33, 33.33, 33.33])
  sectionBlock('section-3col-2-6-2', '3 Col (25/50/25)', col3Icon, [25, 50, 25])
  sectionBlock('section-4col', '4 Columns', col4Icon, [25, 25, 25, 25])

  bm.add('single-column', {
    label: 'Column',
    media: sectionIcon,
    category: 'Layout',
    content: `<div data-gjs-type="${COLUMN_TYPE}" class="eb-column"></div>`,
  })
}
